import { status } from 'src/store/status/statusSlice';
import { AppDispatch } from '@helpers/store';

export const celebrate = (flag: boolean | string) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(status.actions.celebrate(flag));
  };
};
